import { useFormik } from 'formik';
import AuthWrapper from 'shared/components/auth_wrapper/AuthWrapper';
import { resetPasswordVS } from 'shared/utils/validation/AuthValidation';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import styles from './style.module.scss';
import { classNames } from 'shared/utils/Helper';
import Heading from 'shared/components/common/heading/Heading';
import { resetPasswordImage, BackIcon } from 'assets';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';

const ResetPassword = () => {
    const navigate = useNavigate();
    const initialValues = {
        password: '',
        confirmPassword: ''
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: resetPasswordVS,
        onSubmit: (value) => {
            forogtHandler(value);
        }
    });
    const { handleChange, handleSubmit, values, touched, errors } = formik;

    const forogtHandler = (values, action) => {
        navigate(routeConstant.otp.path);
    };
    const handleNavigate = () => {
        navigate(routeConstant.login.path);
    };

    return (
        <AuthWrapper mainImage={resetPasswordImage} heading="“ Use CEPWise TechRA to manage and collaborate in a smoother and more efficient way. ”">
            <div className={classNames(styles.ResetPasswordContainer)}>
                <Heading heading="Reset your password" headingStyle={classNames(styles.ResetHeading)} />
                <div className={classNames(styles.ResetPasswordMainTitle)}>Select your new password</div>
                <CustomInput
                    label="New Password"
                    type="password"
                    placeholder="enter your new password"
                    value={values.password}
                    onChange={handleChange('password')}
                    error={errors.password && touched.password ? errors.password : ''}
                />
                <CustomInput
                    label="Confirm Password"
                    placeholder="confirm your new password"
                    type="password"
                    value={values.confirmPassword}
                    onChange={handleChange('confirmPassword')}
                    error={errors.confirmPassword && touched.confirmPassword ? errors.confirmPassword : ''}
                />

                <CustomButton text="Reset Password" containerStyle={styles.ButtonContainer} submitHandle={handleSubmit} />
                <CustomButton Icon={BackIcon} text="Back to Login" containerStyle={styles.BackButton} IconStyle={styles.Icon} submitHandle={handleNavigate} />
            </div>
        </AuthWrapper>
    );
};

export default ResetPassword;
